import { useState, useEffect, useRef } from "react";
import Menubar from "../Menubar/Menubar";
import { Outlet } from "react-router-dom";
import "../Dashboard/Dashboard.css";
import { FiInfo } from "react-icons/fi";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import Loader from "../Loader/Loader";
import useMinimumLoading from "../hooks/Useminimumloading";
import { MdDelete } from "react-icons/md";
import axios from "axios";
import { API_URL } from "../../Config";

const StaffManagement = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  // const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("menubarOpen");

    if (savedState !== null) {
      return JSON.parse(savedState);
    }

    return window.innerWidth >= 1024;
  });
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const showLoader = useMinimumLoading(loading);
  const [isEditing, setIsEditing] = useState(false);
  const [editingUserId, setEditingUserId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [showInfoPopup, setShowInfoPopup] = useState(false);
  const filteredStaff = users.filter((user) => {
    const query = searchQuery.toLowerCase();
    return (
      user.id.toString().includes(query) ||
      user.name.toLowerCase().includes(query) ||
      (user.role ? user.role.toLowerCase().includes(query) : false)
    );
  });
  // const user = JSON.parse(localStorage.getItem("user"));
  const user = JSON.parse(localStorage.getItem("user") || "null") || null;
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);

      if (mobile) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const navigate = useNavigate();

  // const statusColors = {
  //   CANCELLED: "bg-amber-800/20 text-amber-800",
  //   CONFIRMED: "bg-green-500/20 text-green-500",
  //   BOOKED: "bg-purple-500/20 text-purple-500",
  //   FAILED: "bg-red-500/20 text-red-500",
  //   PENDING: "bg-yellow-200/40 text-yellow-300",
  //   PAID: "bg-transparent text-green-500",
  //   UNPAID: "bg-transparent text-red-400",
  // };

  const table_staff = [
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "Pre-Paid",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
  ];

  const rowsPerPage_staff = 20;
  const [currentPage_staff, setCurrentPage_staff] = useState(1);

  const indexOfLastTable_staff = currentPage_staff * rowsPerPage_staff;
  const indexOfFirstTable_staff = indexOfLastTable_staff - rowsPerPage_staff;

  const current_staff = filteredStaff.slice(
    indexOfFirstTable_staff,
    indexOfLastTable_staff,
  );

  const totalPages_staff = Math.ceil(users.length / rowsPerPage_staff);

  const handlePageChange_staff = (pageNumber_staff) => {
    setCurrentPage_staff(pageNumber_staff);
  };

  const handleNextPage_staff = () => {
    if (currentPage_staff < totalPages_staff) {
      setCurrentPage_staff(currentPage_staff + 1);
    }
  };

  const handlePrevPage_staff = () => {
    if (currentPage_staff > 1) {
      setCurrentPage_staff(currentPage_staff - 1);
    }
  };

  const generatePageNumbers_staff = () => {
    const pageNumbers_staff = [];

    if (totalPages_staff <= 3) {
      for (let i = 1; i <= totalPages_staff; i++) {
        pageNumbers_staff.push(i);
      }
    } else {
      if (currentPage_staff > 2) {
        pageNumbers_staff.push(1);
        pageNumbers_staff.push("...");
      }
      for (let i = currentPage_staff - 1; i <= currentPage_staff + 1; i++) {
        if (i > 0 && i <= totalPages_staff) {
          pageNumbers_staff.push(i);
        }
      }
      if (currentPage_staff < totalPages_staff - 1) {
        pageNumbers_staff.push("...");
        pageNumbers_staff.push(totalPages_staff);
      }
    }
    return pageNumbers_staff;
  };

  const [selectedRows_staff, setSelectedRows_staff] = useState([]);

  const handleRowCheckboxChange_staff = (order) => {
    setSelectedRows_staff((prevSelected) =>
      prevSelected.includes(order)
        ? prevSelected.filter((id) => id !== order)
        : [...prevSelected, order],
    );
  };

  const handleSelectAll_staff = () => {
    if (selectedRows_staff.length === current_staff.length) {
      setSelectedRows_staff([]);
    } else {
      setSelectedRows_staff(current_staff.map((booking) => booking.order));
    }
  };

  const [isOpen_popupForm, setIsOpen_popupForm] = useState(false);

  // const fileInputRef = useRef(null);

  // const handleBoxClick = () => {
  //   fileInputRef.current.click();
  // };

  const [showPopup_filter, setShowPopup_filter] = useState(false);
  const filterRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setShowPopup_filter(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/users`)
      .then((res) => {
        setUsers(res.data);
      })
      .catch((err) => console.error("Error fetching users:", err))
      .finally(() => setLoading(false));
  }, []);

  const handleToggleApproval = (id, checked) => {
    // optimistic UI update
    setUsers((prev) =>
      prev.map((u) =>
        u.id === id ? { ...u, isapproved: checked ? true : false } : u,
      ),
    );

    axios
      .put(`${API_URL}/users/${id}/approve`, {
        isapproved: checked ? true : false,
      })
      .catch((err) => {
        console.error("Failed to update approval:", err);
        // rollback on error
        setUsers((prev) =>
          prev.map((u) =>
            u.id === id ? { ...u, isapproved: checked ? false : true } : u,
          ),
        );
      });
  };
  const handleDeleteUser = (id) => {
    if (!window.confirm("Are you sure you want to delete this user?")) return;

    axios
      .delete(`${API_URL}/users/${id}`)
      .then(() => {
        setUsers((prev) => prev.filter((u) => u.id !== id));
      })
      .catch((err) => {
        console.error("Failed to delete user:", err);
        alert("Failed to delete user");
      });
  };
  const [formData, setFormData] = useState({
    name: "",
    username: "",
    email: "",
    phone: "",
    role: "",
    password: "",
    confirmPassword: "",
    isapproved: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "name") {
      // generate username from full name (lowercase, no spaces)
      const generated =
        value.toLowerCase().replace(/\s+/g, "") +
        Math.floor(Math.random() * 1000);

      setFormData((prev) => ({
        ...prev,
        [name]: value,
        username: generated,
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSave = () => {
    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    if (isEditing) {
      // ✅ Update user
      axios
        .put(`${API_URL}/users/${editingUserId}`, formData)
        .then((res) => {
          alert("User updated successfully");
          setUsers((prev) =>
            prev.map((u) =>
              u.id === editingUserId ? { ...u, ...formData } : u,
            ),
          );
          setIsOpen_popupForm(false);
          setIsEditing(false);
          setEditingUserId(null);
        })
        .catch((err) => {
          console.error("Failed to update user:", err);
          alert("Failed to update user");
        });
    } else {
      // ✅ Add user
      axios
        .post(`${API_URL}/users`, formData)
        .then((res) => {
          alert("User added successfully");
          setUsers((prev) => [...prev, { ...formData, id: res.data.id }]);
          setIsOpen_popupForm(false);
        })
        .catch((err) => {
          console.error("Failed to add user:", err);
          alert("Failed to add user");
        });
    }
  };

  return (
    <div className="flex bg-[#F8F9FA]">
      <Menubar
        isOpen={isSidebarOpen}
        setIsOpen={setIsSidebarOpen}
        isMobile={isMobile}
      />

      <main
        className={`p-5 lg:p-6 transition-all duration-500 w-full ${
          isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
        }`}
      >
        <Outlet />

        {/* Header */}
        <div className="flex justify-between gap-5 items-start lg:items-center">
          <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
            <div className="flex items-center gap-2">
              <span className="font-semibold text-xl text-gray-700">
                Staff Management
              </span>
              {user?.role?.toLowerCase() === "admin" && (
                <FiInfo
                  size={18}
                  className="text-gray-500 cursor-pointer hover:text-black"
                  onClick={() => setShowInfoPopup(true)}
                />
              )}
            </div>
          </div>

          <div className="flex items-center gap-1">
            <div className="flex items-center">
              <div className="mr-2 p-2 overflow-hidden w-8 h-8 hover:w-[120px] sm:hover:w-[250px] hover:border hover:border-[#1D2826] hover:shadow-[2px_2px_20px_rgba(0,0,0,0.08)] rounded-full flex group items-center hover:duration-300 duration-300">
                <div className="flex items-center justify-center fill-[#1D2826]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    id="Isolation_Mode"
                    data-name="Isolation Mode"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                  >
                    <path d="M18.9,16.776A10.539,10.539,0,1,0,16.776,18.9l5.1,5.1L24,21.88ZM10.5,18A7.5,7.5,0,1,1,18,10.5,7.507,7.507,0,0,1,10.5,18Z"></path>
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="border-none outline-none text-sm bg-transparent w-full font-normal px-2 focus:ring-0"
                />
              </div>

              <div className="">
                <button className="Btn">
                  <svg
                    className="svgIcon"
                    viewBox="0 0 384 512"
                    height="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path>
                  </svg>
                  <span className="icon2"></span>
                  <span className="tooltip text-sm">Download</span>
                </button>
              </div>

              <div className="flex items-center">
                <div className="relative inline-block" ref={filterRef}>
                  <div
                    onClick={() => setShowPopup_filter((prev) => !prev)}
                    className={`flex flex-col items-center gap-4 cursor-pointer select-none group scale-[0.75] py-2.5 px-2 rounded-full border-2 transition-all duration-300 ${
                      showPopup_filter
                        ? "border-[#1D2826]"
                        : "border-transparent hover:border-[#1D2826]"
                    }`}
                  >
                    <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? "100%" : "0%",
                          transform: `translate(${
                            showPopup_filter ? "-100%" : "0"
                          }, -50%)`,
                        }}
                      ></div>
                    </div>

                    <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full -my-2.5">
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? "0%" : "100%",
                          transform: `translate(${
                            showPopup_filter ? "0" : "-100%"
                          }, -50%)`,
                        }}
                      ></div>
                    </div>

                    <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? "100%" : "0%",
                          transform: `translate(${
                            showPopup_filter ? "-100%" : "0"
                          }, -50%)`,
                        }}
                      ></div>
                    </div>
                  </div>

                  {showPopup_filter && (
                    <div className="absolute top-full mt-1 right-0 bg-white border rounded-lg shadow-custom z-10 p-4 space-y-4">
                      <div className="flex justify-between gap-2">
                        {["Today", "Week", "Month", "Year"].map((label) => (
                          <button
                            key={label}
                            className="flex-1 py-1 px-2 bg-gray-100 active:bg-[#DAE0CE] hover:bg-[#DAE0CE] rounded text-sm font-medium"
                          >
                            {label}
                          </button>
                        ))}
                      </div>

                      <div className="flex flex-col gap-2">
                        <div className="flex items-center gap-2">
                          <input
                            type="date"
                            className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
                          />
                          <span className="text-sm text-gray-500">-</span>
                          <input
                            type="date"
                            className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Button */}
        <div className="flex justify-between gap-10 mt-8">
          <button
            onClick={() => setIsOpen_popupForm(true)}
            className="px-6 z-30 py-2 bg-[#1D2826] rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-900 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
          >
            + Add Member
          </button>

          <div className="relative z-50">
            {isOpen_popupForm && (
              <div
                onClick={() => setIsOpen_popupForm(false)}
                className="fixed inset-0 bg-black bg-opacity-30 z-40 backdrop_popupForm"
              />
            )}

            <div
              className={`fixed top-0 right-0 h-full w-[85%] md:w-[640px] bg-white z-50 shadow-lg transform transition-transform duration-500 ease-in-out ${
                isOpen_popupForm ? "translate-x-0" : "translate-x-full"
              } panel_popupForm`}
            >
              <div className="p-4 flex justify-between items-center border-b header_popupForm">
                <h2 className="text-[#1D2826] text-lg font-semibold">
                  Add Member
                </h2>
                <button
                  onClick={() => setIsOpen_popupForm(false)}
                  className="text-gray-500 hover:text-black text-xl"
                >
                  <MdCancel />
                </button>
              </div>

              <div className="p-4">
                {/* <div className="font-semibold text-gray-500 text-sm text-right">
                  Member ID: <span className="text-black my-1">10294837</span>
                </div> */}

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-3 items-center max-h-[85vh] overflow-y-auto py-2">
                  <div className="flex flex-col w-full">
                    <label
                      for="input"
                      className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                    >
                      Full Name
                    </label>
                    <input
                      placeholder="Enter first name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                    />
                  </div>

                  <div className="flex flex-col w-full">
                    <label
                      for="input"
                      className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                    >
                      Generated Username
                    </label>
                    <input
                      placeholder="Generated Username"
                      name="username"
                      value={formData.username}
                      readOnly
                      className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                    />
                  </div>

                  <div className="flex flex-col w-full">
                    <label
                      for="input"
                      className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                    >
                      Email
                    </label>
                    <input
                      placeholder="Enter your email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                    />
                  </div>

                  <div className="flex flex-col w-full">
                    <label
                      for="input"
                      className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                    >
                      Phone Number
                    </label>
                    <input
                      placeholder="Enter phone number"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                    />
                  </div>

                  <div className="flex flex-col w-full">
                    <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                      Role
                    </label>

                    <select
                      name="role"
                      value={formData.role}
                      onChange={handleChange}
                      className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                    >
                      <option value="">Select your Role</option>
                      <option value="Admin">Admin</option>
                      <option value="User">User</option>
                      <option value="Manager">Manager</option>
                    </select>
                  </div>
                  <div className="flex flex-col w-full">
                    <label
                      for="input"
                      className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                    >
                      Password
                    </label>
                    <input
                      placeholder="Enter password"
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                    />
                  </div>
                  <div className="flex flex-col w-full">
                    <label
                      for="input"
                      className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                    >
                      Confirm Password
                    </label>
                    <input
                      type="password"
                      placeholder="Confirm password"
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                    />
                  </div>
                  <div className="flex flex-col w-full">
                    <label
                      for="input"
                      className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                    >
                      Approve the user?
                    </label>
                    <select
                      name="isapproved"
                      value={formData.isapproved}
                      onChange={handleChange}
                      className="border-gray-400 p-3 text-sm border rounded-lg w-full"
                    >
                      <option value={0}>Not Approved</option>
                      <option value={1}>Approved</option>
                    </select>
                  </div>
                  <div></div>
                  <div></div>
                  <div className="grid grid-cols-2 gap-3">
                    <button
                      onClick={() => setIsOpen_popupForm(false)}
                      className="px-6 z-30 py-2 bg-gray-800 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-gray-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
                    >
                      Cancel
                    </button>

                    <button
                      onClick={handleSave}
                      className="px-6 z-30 py-2 bg-green-900 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <div>
          <div className="shadow-md rounded-lg mt-5">
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left rtl:text-right text-gray-800">
                <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
                  <tr>
                    <th className="p-4">
                      <input
                        type="checkbox"
                        onChange={handleSelectAll_staff}
                        checked={
                          selectedRows_staff.length === current_staff.length &&
                          current_staff.length > 0
                        }
                      />
                    </th>
                    <th className="p-4">ID</th>
                    <th className="p-4 w-1/10">Username</th>
                    <th className="p-4 w-1/10">Name</th>
                    <th className="p-4 w-1/10">Role</th>
                    <th className="p-4 w-1/12">Email</th>
                    <th className="p-4 w-1/10">Phone</th>
                    <th className="p-4 w-1/10">Approve</th>
                    <th className="p-4 w-1/10">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {showLoader ? (
                    <tr>
                      <td colSpan="10" className="text-center py-5">
                        <Loader
                          label="Loading..."
                          fullScreen={false}
                          className="py-2"
                        />
                      </td>
                    </tr>
                  ) : current_staff.length > 0 ? (
                    current_staff.map((user) => (
                      <tr
                        key={user.id}
                        className="bg-white even:bg-gray-50 border-b hover:bg-gray-100"
                      >
                        <td className="px-4 py-3">
                          <input
                            type="checkbox"
                            onChange={() =>
                              handleRowCheckboxChange_staff(user.order)
                            }
                            checked={selectedRows_staff.includes(user.order)}
                          />
                        </td>
                        <td className="px-4 py-3">{user.id}</td>
                        <td className="px-4 py-3">{user.username}</td>
                        <td className="px-4 py-3">{user.name}</td>
                        <td className="px-4 py-3">{user.role}</td>
                        <td className="px-4 py-3">{user.email}</td>
                        <td className="px-4 py-3">{user.phone || "-"}</td>
                        <td className="px-4 py-3">
                          <label className="relative inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              className="sr-only peer"
                              checked={
                                user.isapproved === true ||
                                user.isapproved === "true"
                              }
                              onChange={(e) =>
                                handleToggleApproval(user.id, e.target.checked)
                              }
                            />

                            {/* Track */}
                            <div className="w-12 h-6 bg-gray-300 rounded-full peer-checked:bg-green-500 transition-colors duration-300"></div>

                            {/* Knob */}
                            <div className="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full shadow-md transition-transform duration-300 peer-checked:translate-x-6"></div>
                          </label>
                        </td>

                        <td className="px-4 py-3">
                          {/* <button className="px-2">
                            <FaEye />
                          </button> */}
                          <button
                            onClick={() => {
                              setIsEditing(true);
                              setEditingUserId(user.id);
                              setFormData({
                                name: user.name,
                                username: user.username,
                                email: user.email,
                                phone: user.phone || "",
                                role: user.role
                                  ? user.role.trim().charAt(0).toUpperCase() +
                                    user.role.slice(1).toLowerCase()
                                  : "",

                                password: user.password,
                                confirmPassword: user.password,
                                isapproved: user.isapproved,
                              });
                              setIsOpen_popupForm(true);
                            }}
                            className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                          >
                            <FaEdit size={15} />
                          </button>
                          <button
                            onClick={() => handleDeleteUser(user.id)}
                            className="px-2 py-1 text-gray-400 hover:text-red-500 hover:dark:text-white hover:scale-125 transition-all duration-300"
                          >
                            <MdDelete size={15} />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center py-5">
                        No users found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <nav
              className="flex items-center flex-column flex-wrap md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]"
              aria-label="Table navigation"
            >
              <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
                Showing{" "}
                <span className="font-semibold text-gray-700 dark:text-white">
                  {indexOfFirstTable_staff + 1}-
                  {Math.min(indexOfLastTable_staff, table_staff.length)}
                </span>{" "}
                of{" "}
                <span className="font-semibold text-gray-700 dark:text-white">
                  {table_staff.length}
                </span>
              </span>

              <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
                <li>
                  <button
                    onClick={handlePrevPage_staff}
                    disabled={currentPage_staff === 1}
                    className="flex items-center justify-center px-1 h-8 ms-0 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                  >
                    <MdKeyboardDoubleArrowLeft />
                  </button>
                </li>
                {generatePageNumbers_staff().map((page, index) =>
                  page === "..." ? (
                    <li
                      key={index}
                      className="px-1 h-8 flex items-center justify-center text-gray-500 bg-[#f7f7f7] border-gray-300 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-700"
                    >
                      <span>...</span>
                    </li>
                  ) : (
                    <li key={index}>
                      <button
                        onClick={() => handlePageChange_staff(page)}
                        className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
                          currentPage_staff === page
                            ? "text-green-500 underline underline-offset-2"
                            : ""
                        }`}
                      >
                        {page}
                      </button>
                    </li>
                  ),
                )}
                <li>
                  <button
                    onClick={handleNextPage_staff}
                    disabled={currentPage_staff === totalPages_staff}
                    className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                  >
                    <MdKeyboardDoubleArrowRight />
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </main>
      {showInfoPopup && user?.role?.toLowerCase() === "admin" && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
          onClick={() => setShowInfoPopup(false)}
        >
          <div
            className="bg-white rounded-xl shadow-xl w-full max-w-md p-6"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-lg font-semibold mb-3">Roles Info</h2>

            <p className="text-gray-600 text-sm">
              <strong>Admin:</strong> &nbsp; Has full access to all features and
              settings.
              <br />
              <br />
              <strong>Manager:</strong>&nbsp; Can manage properties,
              bookings,leads and brochures, but cannot make changes to
              administrative settings .
              {/* administrative settings (e.g., approving users, assigning roles,
              deleting accounts). */}
              <br />
              <br />
              <strong>User:</strong>&nbsp; Can view Properties, Bookings, Leads
              and Brochures but cannot make changes.
            </p>

            <div className="flex justify-end mt-5">
              <button
                onClick={() => setShowInfoPopup(false)}
                className="px-4 py-2 bg-green-800 text-white rounded-md hover:bg-green-700"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StaffManagement;
